import { Container } from "@mui/material";
import React from "react";
import { FaRegCopyright } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-[#0C0C0E] border-t border-[#C8A165]/20 py-2">
      <Container maxWidth="lg">
        <div className="mx-auto px-6 py-3 flex flex-col md:flex-row justify-between items-center text-cream/60 text-xs">
          <div className="flex items-center gap-1.5 uppercase tracking-wider text-center font-medium">
            <FaRegCopyright className="text-gold text-sm" />
            Tanushree Makeup Artist ({new Date().getFullYear()})
          </div>

          <div className="text-xs flex items-center gap-1 mt-2 md:mt-0 text-center font-medium">
            <span>Designed and Developed by -</span>
            <a
              href="tel:+918709278485"
              className="text-[#C8A165] hover:text-[#F5E5C9] font-bold underline decoration-[#C8A165]/50 underline-offset-4 transition-colors"
            >
              Jitendra | +91 8709278485
            </a>
          </div>
        </div>
      </Container>
    </footer>
  );
}
